<template>
  <div>Processing...</div>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { createNamespacedHelpers } from 'vuex'
import axios from 'axios'
import { SPOTIFY_CLIENT } from '../../config'
import { getConfigForNetwork } from '../../utils'

const config = getConfigForNetwork()
const TokenStore = createNamespacedHelpers('TokenStore')
@Component({
  methods: {
    ...TokenStore.mapActions(['getAppTokenByCode'])
  }
})
export default class AuthCallback extends Vue {
  async mounted() {
    const params = this.$route.query
    if (params.code) {
      await this.getAppTokenByCode(params.code)
      this.$router.push({ path: '/channel' })
    }
  }
}
</script>
